/**
 * Traditional Chinese (zh-TW) translations for summary analysis.
 * Detailed star interpretations fall back to zh-CN via the fallback chain.
 */
const summary = {
  summary: {
    title: "性格概述",
    demoData: "示範資料",
    noData: "暫無可用的概述分析資料",
  },
};

export default summary;
